import React, { useEffect, useState, forwardRef } from "react";

const CrystalReport = forwardRef(({ props }, ref) => {
  const [base64Image, setBase64Image] = useState("");

  const logoUrl =
    "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Jharkhand_Rajakiya_Chihna.svg/300px-Jharkhand_Rajakiya_Chihna.svg.png";

  useEffect(() => {
    convertToBase64(logoUrl);
  }, []);

  const convertToBase64 = (url) => {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          setBase64Image(reader.result);
        };
        reader.readAsDataURL(blob);
      })
      .catch((error) => console.error("Error converting image:", error));
  };

  return (
    <div ref={ref} className="text-sm p-4">
     

       {/* Header Section with Logo */}
      <div className="flex flex-col items-center justify-center text-center mb-6">

        <img src={base64Image}

          alt="Jharkhand Emblem"
          className="w-24 h-24 mb-4"
        />
        <h1 className="text-2xl font-bold uppercase">Office</h1>
        <h2 className="text-xl font-semibold">Deputy Commissioner And District Magistrate, Pakur</h2>
        <h3 className="text-lg font-medium italic">(District Confidential Branch)</h3>
      </div>

      {/* Instruction Paragraph */}
      <p className="text-justify leading-relaxed mb-6 text-sm md:text-base">
        For the effective supervision of Allotement and Social activities in Pakur district,
        the following officials/employees are deputed at the designated posts established across the district
        under the direction of the competent authority:
      </p>

      {/* Table Section */}
      <table className="w-full border border-gray-400 text-sm md:text-base mb-6">
        <thead className="bg-gray-100">
          <tr>
           <th className="border p-2">S.No.</th>
           <th className="border p-2">Allottee Deputy</th>
            <th className="border p-2">Designation</th>
           <th className="border p-2">Block Name</th>
           <th className="border p-2">District Name</th>
           <th className="border p-2">Event</th>
           <th className="border p-2">Date</th>
           <th className="border p-2">Time</th>

          </tr>
        </thead>
        <tbody>
          {props.map((item, index) => (
           <tr
              key={item.DutyAllotementCode + index}
              className="odd:bg-white even:bg-gray-50"
            >
              <td className="border p-2 text-center">{index + 1}</td>
              <td className="border p-2 text-center">{item.FullName}</td>
              <td className="border p-2 text-center">{item.Designation}</td>

              <td className="border p-2">{item.AreaName}</td>
              <td className="border p-2">Pakur</td>
              <td className="border p-2 text-center">{item.EventName}</td>
              <td className="border p-2 text-center">
                {new Date(item.EventStartDate).toISOString().split("T")[0]} to{" "}
                {new Date(item.EventEndDate).toISOString().split("T")[0]}
              </td>

              <td className="border p-2 text-center">
                {item.StartTime ? (
                  <>
                    {new Date(
                      `1970-01-01T${item.StartTime}`
                    ).toLocaleTimeString([], {
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                    })}{" "}
                    to{" "}
                    {new Date(`1970-01-01T${item.EndTime}`).toLocaleTimeString(
                      [],
                      {
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                      }
                    )}
                  </>
                ) : (
                  <>
                    {new Date(item.EventStartDate).toLocaleTimeString([], {
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                    })}{" "}
                    to{" "}
                    {new Date(item.EventEndDate).toLocaleTimeString([], {
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Security Personnel List */}
      {/* <div>
        <h2 className="text-lg font-semibold mb-2">List of Security Personnel</h2>
        <ul className="list-disc list-inside text-sm space-y-1">
          <li>Mr. V. J. Jatu P. – Chandauli District Employment Sevak – 9955714971</li>
          <li>Mr. Rakesh Kumar Bharti – Chandauli District Employment Sevak – 7544092636</li>
          <li>Mr. Subhash Haldar – Tulsipur – 7870576728</li>
        </ul>
      </div> */}

      {/* Footer Signature */}
      {/* <div className="mt-10 flex justify-end pr-10">
        <div className="text-right">
          <p className="font-semibold">Signature:</p>
          <p className="italic">District Officer</p>
          <p>Pakur, Jharkhand</p>
        </div>
      </div> */}



    </div>
  );
});

export default CrystalReport;
